import { mapState } from "vuex";
// 列表页通用代码
export default {
    computed: {
        ...mapState(["keys"]),
    },
    data() {
        return {
            loading: false,
            // 总条数
            total: 0,
            // 列表表格数据
            tableData: [],
            ids: [],
            ids_d: [],
            picks: [],
            names: [],
            // 查询参数
            query: {
                page_index: 1,
                page_size: 10,
            },
            module: "",
            formPath: "",
            detailPath: "",
            uuidKey: "uuid",
        };
    },
    methods: {
        permission(key) {
            return this.keys.indexOf(key) > -1;
        },
        _search(params) {
            params = params || this.query;
            this.loading = true;
            this.list(params).then(({ code, result, error }) => {
                if (code === 200) {
                    this.tableData = result.data || result;
                    this.total = result.total;
                    if(this.pick) {
                        this.setChecks();
                    }
                } else {
                    this.$message.error(error.message);
                }
                this.loading = false;
            });
        },
        merge() {
            this.ids.forEach((x) => {
                if (!this.picks.find((n) => n.uuid == x)) {
                    this.picks.push(this.names.find((n) => n.uuid == x));
                }
            });
            this.ids_d.forEach((x) => {
                if (this.picks.find((n) => n.uuid == x)) {
                    this.picks = this.picks.filter((y) => y.uuid !== x);
                }
            });
        },
        setChecks() {
            this.tableData.map((x) => {
                if (this.picks.find((n) => n.uuid == x.uuid)) {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, true);
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, false);
                    });
                }
            });
        },
        handleSelectionChange(row) {
            this.ids = row;
        },
        handleSizeChange(size) {
            this.query.page_size = +size;
            this.handleSearch();
        },
        handleCurrentChange(current) {
            this.query.page_index = +current;
            this.search();
        },
        handleSearch() {
            this.query.page_index = 1;
            this.search();
        },
        resetQuery() {
            this.handleSearch();
        },
        handleAdd() {
            this.$router.push({ path: this.formPath });
        },
        handleEdit(row, query) {
            if (this.uuidKey === "cuuid") {
                this.$router.push({ path: this.formPath, query: { cuuid: row.cuuid, ...query } });
            } else {
                this.$router.push({ path: this.formPath, query: { uuid: row.uuid, ...query } });
            }
        },
        handleDetail(row) {
            if (this.uuidKey === "cuuid") {
                this.$router.push({ path: this.detailPath, query: { cuuid: row.cuuid } });
            } else {
                this.$router.push({ path: this.detailPath, query: { uuid: row.uuid } });
            }
        },
        handleDel({ cuuid, uuid, id }) {
            this.$confirm(`是否删除该${this.module}？`, "提示", { type: "warning" })
                .then(() => {
                    this.del({ uuid, cuuid, id }).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("删除成功");
                            this.search();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                })
                .catch(() => {});
        },
    },
};
